// 쿠키 만료일
export const COOKIE_EXPIRE = 336 * 60 * 60 * 1000

// 문자 전송 옵션 목록
export const smsOptions = [
  { value: '001', label: '미탑승 및 버스 출발 안내' },
  { value: '002', label: '보호자 연락두절' },
  { value: '003', label: '버스 지연 안내' },
]
